import { withStyles } from '@material-ui/styles';
import classNames from 'classnames';
import React from 'react';

const styles = theme => ({
  label: {
    color: 'var(--self-inspect-text-color)',
    fontSize: '1.5rem',
    textAlign: 'left',
    fontWeight: 'bold',

    fontSize: 'clamp(0.75rem, -0.875rem + 8.333333vw, 1.25rem)',
  },

  header: {
    fontSize: 'clamp(1.5rem, -0.875rem + 8.333333vw, 2rem)',
    textAlign: 'center',
  },
});

const SelfInspectQuestionLabel = withStyles(styles)(
  ({ classes, className, style, children, isHeader, dangerouslySetInnerHTML = false }) => {
    return (
      <div
        //
        className={classNames(classes.label, isHeader && classes.header)}
        style={style}
        {...(dangerouslySetInnerHTML
          ? {
              dangerouslySetInnerHTML: {
                __html: children,
              },
            }
          : {
              children,
            })}
      />
    );
  },
);

export default SelfInspectQuestionLabel;
